import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04c1128e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-margin white_background"
}

import {
  Breakpoint,
  CardsGridElements,
  CardsListElements,
  Classes,
  Colors,
  CustomElement,
  GeneralCardSubElements,
  GeneralTableCardElements,
  OrderedCardsList,
  SubElements,
  TableElement,
  TmpList,
} from "@/types";
import {
  adjustColor,
  canArrayVModel,
  canCardListVModel,
  canListVModel,
  canVModel,
  castLayoutRow,
  getBreakpoint,
  getBreakpointClasses,
  getCssColor,
  getCustomMessage,
  getIonicColor,
  getLayout,
  getTableCellSize,
  hasNoData,
  isMatrix,
  isSmaller,
} from "@/utils";
import { IonGrid, IonRow, IonCol } from "@ionic/vue";
import {
  PropType,
  WatchStopHandle,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IonicTable',
  props: {
  emptiness_message: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  data: {
    type: Object as PropType<OrderedCardsList<GeneralTableCardElements>>,
    required: true,
  },
  show_table_dividers: {
    type: Boolean,
    default: false,
  },
  first_row: {
    type: Array<TableElement>,
  },
  first_col: {
    //No cell (0,0)
    type: Object as PropType<TmpList<TableElement[]>>,
  },
  sizes: {
    type: [Array, Object] as PropType<
      string[] | TmpList<TmpList<(string | undefined)[]>>
    >,
    required: true,
  },
  list_breakpoint: {
    type: String as PropType<Breakpoint>,
    default: "sm",
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>, // TODO (5): vedere dove applicare colors e classes alla tabella
  classes: Object as PropType<Classes<CardsListElements | CardsGridElements>>,
},
  emits: [
  "execute_link",
  "signal_event",
  "update:emptiness_message",
  "update:data",
  "update:first_row",
  "update:first_col",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "5ccdf12d": (_unref(lines_color)),
  "78d19848": (_unref(background_color))
}))

const castTableElementArray = (e: any) => e as TableElement[];
const hasFirstColSizes = () => {
  let keys: string[];
  let count = 0;
  let has_sizes = false;

  if (props.first_col != undefined) {
    keys = Object.keys(props.first_col);
    while (
      !(has_sizes =
        props.first_col[keys[count]].find((e) => e.size != undefined) !=
        undefined) &&
      ++count < keys.length
    );
  }

  return has_sizes;
};
const checkVModel = () =>
  props.data.order.find((order_element) => canVModel(order_element.title)) !=
    undefined || canCardListVModel(props.data.cards);
const addListeners = () => {
  watch(
    () => props.data,
    (value) => {
      data_ref.value = value;
    }
  );
  watch(
    () => data_ref.value,
    (value) => {
      emit("update:data", value);
    }
  );
};
const getFlatLayoutIndexes = (
  element: GeneralTableCardElements,
  breakpoint: Breakpoint
) => {
  const actual_layout = getLayout(element.layout, breakpoint);

  let to_ret: number[];

  if (actual_layout == undefined) {
    to_ret = element.content.map((_, i) => i);
  } else if (!isMatrix(actual_layout)) {
    to_ret = (actual_layout as (string | number)[]).map((id) =>
      element.content.findIndex((c) => c.id == id)
    );
  } else {
    to_ret = [];
    actual_layout.forEach((row) => {
      castLayoutRow(row).forEach((e) =>
        element.content.findIndex((c) => c.id == e.id)
      );
    });
  }

  return to_ret;
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
  trigger.value++; // TODO (5): da vedere se si trova metodo migliore (es. breackpoint aggiornato in store)
};
const isCellCentered = (
  key: string | number,
  i: number,
  index: number,
  actual_breakpoint: Breakpoint
): boolean => {
  const classes = data_ref.value.cards[key][i].content[index].classes;

  if (!classes) return true;

  const elements = Object.keys(classes) as SubElements[];

  return elements.every((element) => {
    const breakpointClasses = getBreakpointClasses(
      classes[element],
      actual_breakpoint
    );
    return !Object.entries(breakpointClasses).some(
      ([className, isActive]) =>
        (className === "ion-text-start" || className === "ion-text-end") &&
        isActive
    );
  });
};




const emptiness_message_ref = ref(props.emptiness_message);
const data_ref = ref(props.data);
const first_row_ref = ref(props.first_row);
const first_col_ref = ref(props.first_col);
const has_fr_custom_sizes =
  props.first_row != undefined &&
  props.first_row.find((e) => e.size != undefined) != undefined;
const has_fc_custom_sizes = hasFirstColSizes();
const breakpoint = ref(getBreakpoint(window.innerWidth));
const trigger = ref(0);
const background_color = getCssColor(
  props.colors?.background ?? {
    name: "white",
    type: "var",
  }
);
const lines_color = getCssColor(
  props.colors?.list_borders ?? {
    name: "black",
    type: "var",
    alpha: 0.25,
  }
);

let stopWatch: WatchStopHandle;

if (emptiness_message_ref.value.colors == undefined) {
  emptiness_message_ref.value.colors = {};
}
emptiness_message_ref.value.colors.text = adjustColor(
  props.emptiness_message?.colors?.text,
  props.colors?.text
);

if (first_row_ref.value != undefined) {
  first_row_ref.value.forEach((cell) => {
    if (cell.colors == undefined) {
      cell.colors = {};
    }
    cell.colors.text = adjustColor(cell.colors.text, props.colors?.background, {
      name: "background-color",
      type: "var",
    });
  });
}

if (canVModel(props.emptiness_message)) {
  watch(
    () => props.emptiness_message,
    (value) => {
      emptiness_message_ref.value = value;
    }
  );
  watch(
    () => emptiness_message_ref.value,
    (value) => {
      emit("update:emptiness_message", value);
    }
  );
}
if (hasNoData(props.data)) {
  stopWatch = watch(
    () => props.data,
    (value) => {
      data_ref.value = value;
      if (!hasNoData(value) && checkVModel()) {
        addListeners();
        stopWatch();
      }
    }
  );
} else if (checkVModel()) {
  addListeners();
}
if (props.first_row != undefined && canArrayVModel(props.first_row)) {
  watch(
    () => props.first_row,
    (value) => {
      first_row_ref.value = value;
    }
  );
  watch(
    () => first_row_ref.value,
    (value) => {
      emit("update:first_row", value);
    }
  );
}
if (props.first_col != undefined && canListVModel(props.first_col)) {
  watch(
    () => props.first_col,
    (value) => {
      first_col_ref.value = value;
    }
  );
  watch(
    () => first_col_ref.value,
    (value) => {
      emit("update:first_col", value);
    }
  );
}
onMounted(() =>
  nextTick(() => {
    window.addEventListener("resize", updateBreakpoint);
  })
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateBreakpoint);
});

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_list_card = _resolveComponent("list-card")!

  return (_unref(hasNoData)(data_ref.value))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      background:
        __props.colors?.background != undefined &&
        _unref(getIonicColor)(__props.colors?.background) == undefined,
    })
      }, [
        _createVNode(_component_ionic_element, {
          element: emptiness_message_ref.value,
          "onUpdate:element": _cache[0] || (_cache[0] = ($event: any) => ((emptiness_message_ref).value = $event)),
          onExecute_link: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('execute_link'))),
          onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('signal_event')))
        }, null, 8, ["element"])
      ], 2))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (!_unref(isSmaller)(breakpoint.value, __props.list_breakpoint))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonGrid), { class: "ion-padding" }, {
                default: _withCtx(() => [
                  (first_row_ref.value != undefined)
                    ? (_openBlock(), _createBlock(_unref(IonRow), {
                        key: 0,
                        class: "header ion-text-center ion-align-items-center"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(first_row_ref.value, (cell, i) => {
                            return (_openBlock(), _createBlock(_unref(IonCol), {
                              key: cell.id,
                              "size-xl": 
              _unref(getTableCellSize)(cell.size, __props.sizes, i, 'xl', _unref(has_fr_custom_sizes))
            ,
                              "size-lg": 
              _unref(getTableCellSize)(cell.size, __props.sizes, i, 'lg', _unref(has_fr_custom_sizes))
            ,
                              "size-md": 
              _unref(getTableCellSize)(cell.size, __props.sizes, i, 'md', _unref(has_fr_custom_sizes))
            ,
                              "size-sm": 
              _unref(getTableCellSize)(cell.size, __props.sizes, i, 'sm', _unref(has_fr_custom_sizes))
            ,
                              size: 
              _unref(getTableCellSize)(cell.size, __props.sizes, i, 'xs', _unref(has_fr_custom_sizes))
            
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_component_ionic_element, {
                                  key: cell.id,
                                  element: first_row_ref.value[i],
                                  onExecute_link: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('execute_link'))),
                                  onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('signal_event')))
                                }, null, 8, ["element"]))
                              ]),
                              _: 2
                            }, 1032, ["size-xl", "size-lg", "size-md", "size-sm", "size"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_ref.value.cards[''] != undefined
            ? [
                {
                  key: '',
                  title: _unref(getCustomMessage)('', ''),
                },
              ]
            : data_ref.value.order, (row_order) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (data_ref.value.cards[''] == undefined && __props.show_table_dividers)
                        ? (_openBlock(), _createBlock(_unref(IonRow), {
                            key: row_order.key + '_divider',
                            class: "row ion-align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_ionic_element, {
                                    key: row_order.key,
                                    element: row_order.title,
                                    onExecute_link: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('execute_link'))),
                                    onSignal_event: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('signal_event')))
                                  }, null, 8, ["element"]))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_ref.value.cards[row_order.key], (row, i) => {
                        return (_openBlock(), _createBlock(_unref(IonRow), {
                          key: row_order.key + '_' + row.id,
                          class: "row ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            (first_col_ref.value != undefined)
                              ? (_openBlock(), _createBlock(_unref(IonCol), {
                                  key: 0,
                                  "size-xl": 
                _unref(getTableCellSize)(
                  first_col_ref.value[row_order.key][i].size,
                  __props.sizes,
                  0,
                  'xl',
                  _unref(has_fc_custom_sizes)
                )
              ,
                                  "size-lg": 
                _unref(getTableCellSize)(
                  first_col_ref.value[row_order.key][i].size,
                  __props.sizes,
                  0,
                  'lg',
                  _unref(has_fc_custom_sizes)
                )
              ,
                                  "size-md": 
                _unref(getTableCellSize)(
                  first_col_ref.value[row_order.key][i].size,
                  __props.sizes,
                  0,
                  'md',
                  _unref(has_fc_custom_sizes)
                )
              ,
                                  "size-sm": 
                _unref(getTableCellSize)(
                  first_col_ref.value[row_order.key][i].size,
                  __props.sizes,
                  0,
                  'sm',
                  _unref(has_fc_custom_sizes)
                )
              ,
                                  size: 
                _unref(getTableCellSize)(
                  first_col_ref.value[row_order.key][i].size,
                  __props.sizes,
                  0,
                  'xs',
                  _unref(has_fc_custom_sizes)
                )
              ,
                                  class: "header"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_component_ionic_element, {
                                      key: first_col_ref.value[row_order.key][i].id,
                                      element: first_col_ref.value[row_order.key][i],
                                      onExecute_link: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('execute_link'))),
                                      onSignal_event: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('signal_event')))
                                    }, null, 8, ["element"]))
                                  ]),
                                  _: 2
                                }, 1032, ["size-xl", "size-lg", "size-md", "size-sm", "size"]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFlatLayoutIndexes(
                data_ref.value.cards[row_order.key][i],
                breakpoint.value
              ), (index, j) => {
                              return (_openBlock(), _createBlock(_unref(IonCol), {
                                key: 
                castTableElementArray(data_ref.value.cards[row_order.key][i].content)[
                  index
                ].id
              ,
                                size: 
                Array.isArray(__props.sizes)
                  ? '' + __props.sizes[j + (first_col_ref.value != undefined ? 1 : 0)]
                  : __props.sizes[row_order.key] != undefined &&
                    __props.sizes[row_order.key][row.id] != undefined &&
                    __props.sizes[row_order.key][row.id][j] != undefined
                  ? '' + __props.sizes[row_order.key][row.id][j]
                  : undefined
              ,
                                class: _normalizeClass({
                'ion-text-center': isCellCentered(
                  row_order.key,
                  i,
                  index,
                  breakpoint.value
                ),
              })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ionic_element, {
                                    element: 
                  castTableElementArray(
                    data_ref.value.cards[row_order.key][i].content
                  )[index]
                ,
                                    "onUpdate:element": ($event: any) => ((
                  castTableElementArray(
                    data_ref.value.cards[row_order.key][i].content
                  )[index]
                ) = $event),
                                    onExecute_link: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('execute_link'))),
                                    onSignal_event: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('signal_event')))
                                  }, null, 8, ["element", "onUpdate:element"])
                                ]),
                                _: 2
                              }, 1032, ["size", "class"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  }), 256))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(isSmaller)(breakpoint.value, __props.list_breakpoint))
          ? (_openBlock(), _createBlock(_component_list_card, {
              key: trigger.value,
              onExecute_link: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('execute_link'))),
              onSignal_event: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('signal_event'))),
              emptiness_message: emptiness_message_ref.value,
              "onUpdate:emptiness_message": _cache[13] || (_cache[13] = ($event: any) => ((emptiness_message_ref).value = $event)),
              cards_list: data_ref.value,
              "onUpdate:cards_list": _cache[14] || (_cache[14] = ($event: any) => ((data_ref).value = $event)),
              colors: __props.colors,
              classes: __props.classes
            }, null, 8, ["emptiness_message", "cards_list", "colors", "classes"]))
          : _createCommentVNode("", true)
      ], 64))
}
}

})